import { Select as IdskSelect } from '@mc-ui/idsk-react-components';

import { withReactHookForm } from '../hoc/withReactHookForm';

export const Select = withReactHookForm(IdskSelect);
